var _linearGradient, _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M28 25h8v28h-8zm24-4h8v32h-8zM40 43h8v10h-8zM4 29h8v24H4zm12 6h8v18h-8z",
    className: "colorff5023 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 11,
    r: 3,
    fill: "url(#gradient)",
    className: "color00d7df svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 29,
    r: 3,
    fill: "url(#gradient)",
    className: "color00d7df svgShape"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15,
    r: 3,
    fill: "url(#gradient)",
    className: "color00d7df svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 3,
    fill: "url(#gradient)",
    className: "color00d7df svgShape"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 7,
    r: 3,
    fill: "url(#gradient)",
    className: "color00d7df svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M3 56h58v4H3z",
    className: "color00d7df svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient)",
    d: "M8 19a3.975 3.975 0 0 0 3-1.382l5.091 2.546A4 4 0 1 0 23.6 19.3l6.071-5.053a3.864 3.864 0 0 0 3.634.52l7.719 11.587a4 4 0 1 0 5.7-.259l8.3-15.223A3.942 3.942 0 0 0 56 11a4.029 4.029 0 1 0-2.727-1.09l-8.3 15.223a3.672 3.672 0 0 0-2.28.105l-7.721-11.587a4 4 0 1 0-6.576-.946l-6.071 5.053a3.946 3.946 0 0 0-5.325.624l-5.091-2.546A4 4 0 1 0 8 19zM56 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM46 29a2 2 0 1 1-2-2 2 2 0 0 1 2 2zM32 9a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM20 19a2 2 0 1 1-2 2 2 2 0 0 1 2-2zM8 13a2 2 0 1 1-2 2 2 2 0 0 1 2-2z",
    className: "color008f95 svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.72103b63470c2b1294a745c189b73087.svg";
export { ForwardRef as ReactComponent };